module.exports = __webpack_public_path__ + "media/youtube-intro.8a8031ff.mp4";